



























import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class headPanel extends Vue {
   
    time="";
    timeId:any=null;
    userInfo:any={};
    public $refs: {
    };
    created() {
    }
    mounted() {
        // this.timeId = setInterval(() => {
        //     this.time = dayjs().add(1, 'second').format('YYYY-MM-DD HH:mm:ss');
        // }, 1000);

        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
        
    }

    beforeDestroy(){
      if (this.timeId) {
        clearInterval(this.timeId)
      }
    }

    logoutFun(){
        this.$emit("logoutFun")
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/mainPage/components/headPanel.vue